import { FlexiCloseButton } from "@flexinet/ui-components";

interface CloseButtonProps {
    onClick: () => void;
}

export const CloseButton = ({ onClick }: CloseButtonProps) => {
    return <FlexiCloseButton onClick={onClick} />;
};
